import { shops } from "./shopReducer";

export default shops;